import FormattedMessage from 'I18n/components/FormattedMessage';
import { UpgradeLink } from '../UpgradeLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SmartFillActionsTooltip = ({
  canUpgrade = false,
  upgradeSource
}) => {
  if (canUpgrade) {
    return /*#__PURE__*/_jsxs("span", {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "smartProperties.actions.message"
      }), ' ', /*#__PURE__*/_jsx(UpgradeLink, {
        upgradeSource: upgradeSource,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "smartProperties.actions.cta"
        })
      })]
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "smartProperties.actions.noAccessManualContactAdmin"
  });
};